module.exports = __webpack_public_path__ + "img/1.dbe64cc1.png";